// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-bar{position:relative;z-index:1;width:100%}.search-bar button{right:8px;top:6px}", ""]);
// Exports
module.exports = exports;
